/* eslint-disable no-underscore-dangle */
import { env } from "./env";
export const RUNTIME_CONFIG_URL = typeof __RUNTIME_CONFIG_URL__ === "undefined" ? "/config.json" : __RUNTIME_CONFIG_URL__;
let runtimeConfig = {};
const exposeRuntimeConfig = () => {
    if (typeof window !== "undefined") {
        window.__config = runtimeConfig;
    }
};
export const loadRuntimeConfig = async () => {
    try {
        const response = await fetch(RUNTIME_CONFIG_URL, { cache: "no-store" });
        runtimeConfig = response.ok ? (await response.json()) : {};
    }
    catch {
        // No runtime overrides available (e.g. local dev): fall back to build-time defaults
        runtimeConfig = {};
    }
    exposeRuntimeConfig();
    return runtimeConfig;
};
export const getConfig = (name) => {
    const override = runtimeConfig[name];
    if (override !== undefined) {
        return override;
    }
    const buildTimeConfig = (env() || {});
    return buildTimeConfig[name];
};
export const getHostName = () => window?.location?.hostname ?? "";
